import React, { useState, useContext } from 'react';

const WizardContext = React.createContext({
    currentStep: 0, goToNextStep: () => null, goToPreviousStep: () => null, goToStep: () => null
});

export default function WizardContextContainer({ children }) {
    const [currentStep, setCurrentStep] = useState(0);

    const goToNextStep = () => {
        setCurrentStep(currentStep + 1);
    };
    const goToPreviousStep = () => {
        setCurrentStep(currentStep - 1);
    };
    const goToStep = (index) => {
        setCurrentStep(index);
    };
    return <WizardContext.Provider value={{ currentStep, goToNextStep, goToPreviousStep, goToStep }}>{children}</WizardContext.Provider>;
}


export const useWizard = () => {
    const context = useContext(WizardContext);
    return context;
};